<template>
  <!-- <v-divider class="mt-n2 mx-0"> </v-divider> -->
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class="mt-5 ma-2" v-else>
      <v-data-table
        dense
        :headers="headers"
        :items="itemsCategary"
        :search="search"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ itemsCategary.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.cat_code`]="{ item }">
          <span class="caption" v-if="item.cat_code != null">{{
            item.cat_code
          }}</span>
          <span class="caption" v-if="item.cat_code == null">-</span>
        </template>
        <template v-slot:[`item.cat_desc`]="{ item }">
          <span class="caption">{{ item.cat_desc }}</span>
        </template>

        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="green--text" v-if="item.status == 1">ACTIVE</span>
          <span class="red--text" v-if="item.status == 0">DELETED</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon
            small
            @click="Edit(item)"
            :disabled="item.is_mapped != 1 && item.status == 0"
            color="primary"
            >mdi-pencil</v-icon
          >

          <v-icon
            small
            @click="Delete(item)"
            color="red"
            :disabled="item.status == 0"
            >mdi-delete</v-icon
          >
        </template>
        <template v-slot:top>
          <v-layout row wrap class="mb-2">
            <v-row>
              <!-- <v-col cols="3"> -->
              <v-card-title class="ml-2 primary--text">
                <v-btn @click="back" class="ml-n3 primary--text" text>
                  <v-icon>mdi-reply</v-icon></v-btn
                >

                Category<span
                  style="
                    font-style: italic;
                    font-family: Times New Roman;
                    font-size: 14px;
                  "
                  class="text-left font-weight: 20 primary--text ml-2"
                  >(Create Different Expense Category)</span
                >
                <!-- <v-divider vertical class="ml-5 mx-0"></v-divider> -->
              </v-card-title>

              <!-- </v-col> -->
              <v-spacer></v-spacer>
              <v-col cols="12" sm="12" xl="3" xs="12" lg="3" md="3">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-1 ml-3 mr-3"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                xl="2"
                xs="12"
                lg="2"
                md="2"
                class="mt-1 ml-3 mr-3"
              >
                <v-dialog persistent v-model="createCard" width="600">
                  <template #activator="{ on: createCard }">
                    <!-- <v-tooltip bottom color="primary">
                      <template #activator="{ on: tooltip }"> -->
                    <v-btn
                      class="navbar white--text mt-1 elevation-0"
                      dense
                      rounded
                      v-on="{ ...createCard }"
                    >
                      <v-icon>mdi-plus</v-icon>Add
                    </v-btn>
                    <!-- </template>
                      <span class="white--text">Add</span>
                    </v-tooltip> -->
                  </template>
                  <v-card class="elevation-0">
                    <v-toolbar dark dense class="header">
                      <v-icon>mdi-plus</v-icon>
                      <span class="ml-3">Add Category</span>
                      <v-spacer></v-spacer>
                      <v-btn class text dark @click="closecategory()">
                        <v-icon color="white" small>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="mt-6">
                      <v-form ref="formCat" lazy-validation>
                        <v-row layout align="center" justify="center">
                          <v-col
                            cols="12"
                            sm="12"
                            xl="12"
                            xs="12"
                            lg="12"
                            md="12"
                          >
                            <v-text-field
                              dense
                              outlined
                              :rules="[
                                (v) => !!v || 'Required',

                                (v) =>
                                  v.length <= 85 ||
                                  'Category Name must be less than 85 characters',
                              ]"
                              v-model="createName"
                              @input="getmccDetails(createName)"
                              label="Category Name*"
                              maxlength="85"
                              @keydown.space="preventLeadingSpace"
                            ></v-text-field>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="12"
                            xl="12"
                            xs="12"
                            lg="12"
                            md="12"
                            class="mt-n6"
                          >
                            <v-textarea
                              v-model="maccDetails.combined_description"
                              color="primary"
                              :rules="[(v) => !!v || 'Required']"
                              rows="1"
                              auto-grow
                              maxlength="100"
                              label="Description *"
                              required
                              outlined
                              counter
                              dense
                              @keydown.space="preventLeadingSpace"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        rounded
                        width="90px"
                        color="primary"
                        class="mt-n6"
                        dark
                        @click="createCardMu()"
                        >Add</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="EditCategory" width="600">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-pencil</v-icon>
          <span class="ml-3">Edit Category</span>
          <v-spacer></v-spacer>

          <v-btn class text dark @click="closedialogNew">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-divider></v-divider>
          <v-form ref="form">
            <v-row class="mt-8 mx-7">
              <v-text-field
                v-model="EditCat"
                label="Category Name *"
                color="primary"
                :rules="[
                  (v) => !!v || 'Required',
                  (v) =>
                    /^([a-zA-Z0-9 ]{0,85}$)[0-9 ]{0,85}$/.test(v) ||
                    'Invalid Input',
                  (v) =>
                    (v && v.length <= 85) ||
                    'Category Name must be less than 85 characters',
                ]"
                required
                outlined
                dense
                maxlength="85"
                @keydown.space="preventLeadingSpace"
              ></v-text-field>
            </v-row>
            <v-row class="mx-7">
              <v-textarea
                v-model="EditDescr"
                color="primary"
                :rules="[
                  (v) => !!v || 'Required',
                  (v) => (v && v.length >= 5) || 'Minimum 5 characters',
                  (v) =>
                    (v && v.length <= 100) ||
                    'Name must be less than 100 characters',
                ]"
                rows="1"
                auto-grow
                maxlength="100"
                label="Description *"
                required
                outlined
                counter
                dense
                @keydown.space="preventLeadingSpace"
              ></v-textarea>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              class="primary white--text mr-2 mt-5"
              medium
              @click="Editcategry"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmDeleteDialog1" width="400" persistent>
        <v-card class="overflow-hidden">
          <v-toolbar class="elevation-0" dense>
            <span> Are you sure you want to submit ? </span>
            <v-spacer></v-spacer>
            <!-- <v-btn class text dark @click="assigndialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn> -->
          </v-toolbar>
          <!-- <v-card-text> Are You Sure You Want to Submit? </v-card-text> -->

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-row class="mt-2" style="margin-left: 200px">
              <v-btn
                text
                width="90px"
                class="mb-4 red--text"
                @click="closeDeleteDialog"
                >Back</v-btn
              >
              <v-btn
                text
                width="90px"
                class="mb-4 primary--text"
                @click="deleteItem()"
                >Submit</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import moment from "moment";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

var api = require("mcc");
export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    checkaccessdata: {},

    confirmDeleteDialog1: false,
    Status: "",
    IsMapped: 0,
    catIdDel: "",
    IsMappedDel: 0,
    catId: "",
    overlay: false,
    combined_description: "",
    search: "",
    EditDescr: "",
    EditCat: "",
    // nameRules: [(v) => !! v || "Name is required"],
    maccDetails: {},
    itemsCategary: [],
    Nodata: "",
    createCard: false,
    createName: "",
    headers: [
      // { text: "Sl. No.", sortable: false },
      { text: "SL NO", value: "sl_no" },
      {
        text: "CATEGORY NAME",
        value: "cat_code",
      },
      { text: "DESCRIPTION", value: "cat_desc" },
      {
        text: "CREATED ON",
        value: "created_on",
      },
      {
        text: "STATUS",
        value: "status",
      },
      {
        text: "ACTION",
        value: "action",
      },
    ],
    EditCategory: false,
  }),
  created() {
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "SETTINGS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getCatDetails();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    async createCardMu() {
      if (this.$refs.formCat.validate()) {
        var inputData = {
          method_name: "ADMINSET",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CATINSERT",
            cat_code: this.maccDetails.mcc,
            cat_desc: this.maccDetails.combined_description,
            corp_id: this.$store.getters.get_corpid, // 0
          },
        };
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });

          this.createCard = false;
          this.$refs.formCat.reset();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.$refs.formCat.reset();
          this.createCard = false;
        }
        this.getCatDetails();
      }

      // console.log(responseData.data);
    },
    async getmccDetails(name) {
      var maccDetailss = api.get(name);

      if (maccDetailss == undefined) {
        this.maccDetails = {
          mcc: name,
          combined_description: this.maccDetails.combined_description,
        };
      } else {
        this.maccDetails = maccDetailss == undefined ? {} : maccDetailss;
      }
    },
    closecategory() {
      this.$refs.formCat.reset();
      this.createCard = false;
    },
    async getCatDetails() {
      this.overlay = true;
      var inputData = {
        method_name: "ADMINSET",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "CATGET",
          search_text: "",
          corp_id: this.$store.getters.get_corpid, // 0
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.itemsCategary = responseData.data.data;
          for (let i = 0; i < this.itemsCategary.length; i++) {
            this.Status = this.itemsCategary[i].status;
            // console.log("Status", this.Status);
          }
        }
        // console.log("itemsCategary", this.itemsCategary);
        this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.itemsCategary = [];
        this.overlay = false;
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
    async Editcategry() {
      if (this.$refs.form.validate()) {
        var inputData = {
          method_name: "SETTINGS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "EDCAT",
            type: 1,
            category_code: this.EditCat,
            category_desc: this.EditDescr,
            category_id: this.catId,
            corp_id: this.$store.getters.get_corpid,
          },
        };
        var responseData = await apiCall(inputData);
        this.deplist = responseData;
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.EditCategory = false;

          this.getCatDetails();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
      }
    },
    Edit(item) {
      // console.log("idf", item);
      this.EditCategory = true;
      // this.Name = item.name;
      this.EditCat = item.cat_code;
      this.EditDescr = item.cat_desc;
      this.IsMapped = item.is_mapped;
      this.catId = item.cat_id;
    },
    Delete(item) {
      // console.log("idf", item);
      this.confirmDeleteDialog1 = true;
      // this.Name = item.name;

      this.IsMappedDel = item.is_mapped;
      this.catIdDel = item.cat_id;
    },
    closedialogNew() {
      this.EditCategory = false;
      // this.$store.commit("SET_dialogcheck", false);
    },
    async deleteItem() {
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EDCAT",
          type: 2,

          category_id: this.catIdDel,
          corp_id: this.$store.getters.get_corpid,
        },
      };
      // console.log("cardmaster_id", this.cardmaster_id);
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        this.confirmDeleteDialog1 = false;
        this.$store.commit("snackbar/showMessage", {
          content: "Deleted successfully",
          color: "green",
        });
        this.getCatDetails();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.confirmDeleteDialog1 = false;
      }
    },
    closeDeleteDialog() {
      this.confirmDeleteDialog1 = false;
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
